import React from "react";
import { Tooltip } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { i18n } from "../../../translate/i18n";

// ⓘ explicativo de métricas — SOLO modo PC (isTV oculta el ícono).
// El texto sale de aiAssistantStats.tooltips.<tipKey>.
const InfoTip = ({ tipKey, isTV = false, placement = "top" }) => {
  if (isTV) return null;
  const title = i18n.t(`aiAssistantStats.tooltips.${tipKey}`);
  return (
    <Tooltip title={title} placement={placement} arrow enterTouchDelay={0}>
      <InfoOutlined
        aria-label={title}
        style={{
          fontSize: 15,
          color: "#9e9e9e",
          marginLeft: 4,
          verticalAlign: "middle",
          cursor: "help",
        }}
      />
    </Tooltip>
  );
};

export default InfoTip;
